<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="prf">
<h1 class="chapter"><a id="page1"></a>Preface</h1>
<p class="nonindent">In a letter dated 27 September 1961 Italo Calvino wrote to Niccolò Gallo: ‘As for collecting essays as occasional and disparate as my own, one should really wait until the author is either dead or at least in advanced old age.’</p>
<p class="indent">Despite this, Calvino did begin to collect his non-fiction in 1980, with the volume <em>Una pietra sopra (Closing the Door)</em>, followed in 1984 by <em>Collezione di sabbia (Collection of Sand)</em>. Subsequently he authorised for his overseas readership a selection which was the English, American and French equivalent of <em>Una pietra sopra</em>, but which was not identical to the Italian original: it included the essays on Homer, Pliny, Ariosto, Balzac, Stendhal and Montale, as well as the title essay of the present volume. Later still he modified some of the titles of these essays — and in one case, the article on Ovid, he added another page which he left in manuscript form — with a view to publishing them in a subsequent Italian collection.</p>
<p class="indent">In this volume the reader will find most of the essays and articles by Calvino on ‘his’ classics: the writers, poets and scientific authors who had meant most to him, at different stages of his life. In the case of twentieth-century authors, priority has been given to the essays on those writers and poets whom Calvino held in particular esteem.</p>
<p class="right">Esther Calvino</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Calv_9780307549310_epub_prf_r1.vue?2ecfc812